export default {
  auth: 'requestAuth',
  changeCard: 'requestCardChange',
  payment: 'requestPayment',
  advance: 'requestAdvance',
  share: 'requestShare',
  termsAndCond: 'requestTermsAndConditions',
};
